import { PlasticsHardwareItemType } from "../enums/plastics-hardware-item-type.enum";

export const PlasticsHardwareItemTypePrefix: Record<PlasticsHardwareItemType, string> = {
    [PlasticsHardwareItemType.Colorant]: 'C',
    [PlasticsHardwareItemType.Decorative]: 'D',
    [PlasticsHardwareItemType.Electronics]: 'E',
    [PlasticsHardwareItemType.Fastener]: 'F',
    [PlasticsHardwareItemType.Sealing]: 'S',
    [PlasticsHardwareItemType.CustomerSupplied]: 'CS',
    [PlasticsHardwareItemType.Printed]: 'P',
    [PlasticsHardwareItemType.Miscellaneous]: 'M',
    [PlasticsHardwareItemType.MetalsSupplied]: 'MS',
    [PlasticsHardwareItemType.Insert]: 'I',
    [PlasticsHardwareItemType.Packaging]: 'P',
    [PlasticsHardwareItemType.Resin]: 'R',
    [PlasticsHardwareItemType.Spinweld]: 'SW',
    [PlasticsHardwareItemType.Wheel]: 'W',
    [PlasticsHardwareItemType.ShopSupplies]: 'SS',
};